import axios from "../http";

class Logistics {
  //添加运费规则(待定)
  postLogisticsPice(data) {
    const url = "/zwy/api/express/add";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //客户列表
  getCustomerData() {
    const url = "/zwy/api/customer/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //快递列表
  getExpressData() {
    const url = "/zwy/api/express/type/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //客户快递列表
  getCustomerExpressList(customerId, expressType) {
    const url = `/zwy/api/express/cus/rule/list?customerId=${customerId}&expressType=${expressType}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取客户快递详情
  getExpressRuleList(customerId, expressType) {
    const url = `/zwy/api/express/cus/rule?customerId=${customerId}&expressType=${expressType}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增客户快递
  postAddExpressRule(data) {
    const url = "/zwy/api/express/cus/rule/add";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //删除客户快递
  postDeleteExpressRule(data) {
    const url = "/zwy/api/express/cus/rule/del";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //客户添加前查看快递计费类型
  getExpressMethod(customerId, expressType) {
    const url = `/zwy/api/express/cus/rule/express/method?customerId=${customerId}&expressType=${expressType}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //现场定价保存
  postAddExpressMethod(data) {
    const url = "/zwy/api/express/cus/rule/add/method";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //取整规则列表
  getRoundList() {
    const url = '/zwy/api/express/roundType/list';
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // // 获取客户取整规则区间
  // getLogisticsRoundList(customerId, expressType, sort) {
  //   const url = `/zwy/api/express/cus/roundType/list?customerId=${customerId}&expressType=${expressType}&sort=${sort}`;
  //   return axios.get(url).then(res => {
  //     return Promise.resolve(res.data);
  //   });
  // }
  // // 获取承运商取整规则区间
  // getExpressRoundList(warehouseId, expressType) {
  //   const url = `/zwy/api/express/carrier/roundType/list?warehouseId=${warehouseId}&expressType=${expressType}`;
  //   return axios.get(url).then(res => {
  //     return Promise.resolve(res.data);
  //   });
  // }

  /* 客户快递规则基础信息新增 */
  postAddBaseInfo(data) {
    const url = "/zwy/api/express/cus/rule/base/info/add";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Logistics;
